import React from 'react';
import Overlay from '../../partials/white_overlay';

const Goals = () => {
    return (
        <div style={{ position: 'relative' }}>
            <Overlay />
            <div className="p-4 hind" style={{ mixBlendMode: 'screen' }}>
                <h2 className="hind">Goals & Goal Boxes</h2>
                <p>The goal box, 12 feet wide and 8 feet deep, is directly in front of the goal. No player may touch the ball within the goal box; however, any player may move through the goal box. Any part of the ball or player’s body on the line is considered in the goal box; the player is an extension of the box.</p>
                <p>The box rule is only invoked if a player touches the ball when either any part of the player or the ball is in the box. The box area extends upward from the lines. Touching the ball in the air above the box is a violation.</p>
                <p>If a defender touches the ball in the goal box, a goal is awarded to the offensive team. If the defender OR the ball is in the box and contact is made, a goal is awarded. If an offensive player touches the ball within the goal box, a goal kick is awarded to the defensive team. If the ball comes to a complete stop in the goal box, regardless of which team touched it last, a goal kick is awarded to the defensive team.</p>
                <p>A goal can only be scored when last touched (by either team) while in the OFFENSIVE half of the field. A goal cannot be scored directly from a kick off. For a goal to be awarded during a kick-off, the ball must first be kicked completely off the halfway line, into the offensive half of the field. If the entire ball is not completely within the offensive half of the field when last touched, no goal will be awarded.</p>
            </div>
        </div>
    );
}

export default Goals;



// WEBPACK FOOTER //
// ./src/components/rules/partials/goals.js